import styled from 'styled-components';
import BottomFooter from 'gatsby-theme-pdv/src/components/footer/bottom-footer';

export default styled(BottomFooter)`
  && {
    background-color: #292929;
  }
`;
